import ourAgency from './OurAgency.json';

export const OurAgencyPresentation = ({ lang }) => {
    const history = lang === 'en' ? ourAgency.history[1] : ourAgency.history[0];
    
  return (
    <>
        <p>{ history }</p>
    </>
  )
}
